import { useParams } from 'react-router-dom'
import { ListingWizardForm } from '@/modules/cars/components/listing/listing-wizard-form'
import { useCarDetails } from '@/modules/cars/hooks/use-cars'
import { Loader2 } from 'lucide-react'

export function DealerEditCarPage() {
  const { id } = useParams<{ id: string }>()
  const { data, isLoading } = useCarDetails(id || '')

  if (isLoading) {
    return (
      <div className="p-12 text-center flex flex-col items-center justify-center space-y-3">
        <Loader2 className="size-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Loading vehicle details for editing...</p>
      </div>
    )
  }

  return (
    <div className="py-4 space-y-6">
      <h1 className="font-display text-2xl font-bold tracking-tight">Edit Inventory Vehicle #{id}</h1>
      <ListingWizardForm initialData={data?.listing} isEdit redirectPath="/dealer/cars" />
    </div>
  )
}
